// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dynamic-form-question__element{
    background: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    padding: var(--space-and-half);
    border-radius: var(--space-half-quarter);
    margin-bottom: var(--space-and-half);
}

.dynamic-form-question__question{
    display: flex;
    justify-content: space-between;
}
.dynamic-form-question__question .input-field{
    margin: 0;
    width: 60%;
    margin-right: var(--space-and-half);
}
.dynamic-form-question__question .input-field-input{
    font-size: 14px; 
}
.dynamic-form-question__question .select-field {
    width: 50%;
    margin: 0;
}

.dynamic-form-question__question .select-field .MuiInput-underline:before{
    border: none;
}

.dynamic-form-question__question .select-field .MuiInput-underline:hover:not(.Mui-disabled):before{
    border: none;
}

.dynamic-form-question__question .select-field-input{
    background-color: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    font-size: 14px !important; 
    font-family: var(--secondary-font) !important;
}

.dynamic-form-question__question .MuiSelect-select:focus {
    background-color: var(--white-color);
}

.dynamic-form-question__options{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: var(--space-and-half);
}
.dynamic-form-question__options_switch{
    font-size: 14px; 
    font-family: var(--secondary-font);
}

.dynamic-form-question__remove-element {
    cursor: pointer;
    display: flex;
    align-items: center;
}

.dynamic-form-question__list_answers{
    display: flex;
    flex-direction: column;
}

.dynamic-form-question__answers_options{
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-items: start;
}

.dynamic-form-question__answers_options .input-field{
    margin: var(--space);
}

.tournament-dynamic-form-answer__checkbox {
    visibility: hidden;
}

.dynamic-form-question__answers_options__single-choice {
    width: var(--space-and-half);
    height: var(--space-and-half);
    border-radius: 50%;
    border: 3px solid #0000008a;
}

.dynamic-form-question__answers_options__multi-choice {
    width: var(--space-and-half);
    height: var(--space-and-half);
    border-radius: 4px;
    border: 3px solid #0000008a;
}

.dynamic-form-question__remove-element .hubicon-delete_question {
    font-size: var(--space-x2);
    color: var(--basic-gray-color);
    margin-right: var(--space-half);
}

.dynamic-form-question__remove-element .baloa-table {
    color: var(--error-color);
    font-size: var(--space);
    line-height: 18px;
    padding-top: var(--space-quarter);
}

.tournament-dynamic-form-question__add-btn {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.tournament-dynamic-form-question__add-btn .baloa-table-column {
    color: var(--new-green-color);
    font-size: var(--space);
    margin-left: var(--space-half-quarter);
    line-height: var(--space-and-half);
}

.tournament-dynamic-form-question__add-btn .hubicon-add_option {
    color: var(--new-green-color);
    font-size: var(--space-and-half);
}

.tournament-dynamic-form-question__boolean-type {
    display: flex;
    align-items: center;
}

.tournament-dynamic-form-question__boolean-type span {
    width: 20px;
    height: 20px;
    border: 3px solid rgba(0, 0, 0, 0.6);
    border-radius: 50%;
}

.tournament-dynamic-form-question__boolean-type .baloa-username {
    line-height: var(--space-and-half);
    color: var(--primary-dark-color);
    margin-left: var(--space-half);
}

.tournament-dynamic-form-question__boolean-type__container {
    margin-top: var(--space-and-half);
}

.tournament-dynamic-form-question__boolean-type:first-of-type {
    margin-bottom: var(--space);
}

.input-field__tip-message__wicon {
    display: flex;
    align-items: center;
}

.input-field__tip-message__wicon .hubicon-info {
    margin-right: 4px;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-dynamic-form-question/TournamentDynamicFormQuestionComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,kDAAkD;IAClD,8BAA8B;IAC9B,wCAAwC;IACxC,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,SAAS;IACT,UAAU;IACV,mCAAmC;AACvC;AACA;IACI,eAAe;AACnB;AACA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,kDAAkD;IAClD,0BAA0B;IAC1B,6CAA6C;AACjD;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iCAAiC;AACrC;AACA;IACI,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,gCAAgC;IAChC,8BAA8B;AAClC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".dynamic-form-question__element{\n    background: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    padding: var(--space-and-half);\n    border-radius: var(--space-half-quarter);\n    margin-bottom: var(--space-and-half);\n}\n\n.dynamic-form-question__question{\n    display: flex;\n    justify-content: space-between;\n}\n.dynamic-form-question__question .input-field{\n    margin: 0;\n    width: 60%;\n    margin-right: var(--space-and-half);\n}\n.dynamic-form-question__question .input-field-input{\n    font-size: 14px; \n}\n.dynamic-form-question__question .select-field {\n    width: 50%;\n    margin: 0;\n}\n\n.dynamic-form-question__question .select-field .MuiInput-underline:before{\n    border: none;\n}\n\n.dynamic-form-question__question .select-field .MuiInput-underline:hover:not(.Mui-disabled):before{\n    border: none;\n}\n\n.dynamic-form-question__question .select-field-input{\n    background-color: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    font-size: 14px !important; \n    font-family: var(--secondary-font) !important;\n}\n\n.dynamic-form-question__question .MuiSelect-select:focus {\n    background-color: var(--white-color);\n}\n\n.dynamic-form-question__options{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: var(--space-and-half);\n}\n.dynamic-form-question__options_switch{\n    font-size: 14px; \n    font-family: var(--secondary-font);\n}\n\n.dynamic-form-question__remove-element {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n}\n\n.dynamic-form-question__list_answers{\n    display: flex;\n    flex-direction: column;\n}\n\n.dynamic-form-question__answers_options{\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    justify-items: start;\n}\n\n.dynamic-form-question__answers_options .input-field{\n    margin: var(--space);\n}\n\n.tournament-dynamic-form-answer__checkbox {\n    visibility: hidden;\n}\n\n.dynamic-form-question__answers_options__single-choice {\n    width: var(--space-and-half);\n    height: var(--space-and-half);\n    border-radius: 50%;\n    border: 3px solid #0000008a;\n}\n\n.dynamic-form-question__answers_options__multi-choice {\n    width: var(--space-and-half);\n    height: var(--space-and-half);\n    border-radius: 4px;\n    border: 3px solid #0000008a;\n}\n\n.dynamic-form-question__remove-element .hubicon-delete_question {\n    font-size: var(--space-x2);\n    color: var(--basic-gray-color);\n    margin-right: var(--space-half);\n}\n\n.dynamic-form-question__remove-element .baloa-table {\n    color: var(--error-color);\n    font-size: var(--space);\n    line-height: 18px;\n    padding-top: var(--space-quarter);\n}\n\n.tournament-dynamic-form-question__add-btn {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n\n.tournament-dynamic-form-question__add-btn .baloa-table-column {\n    color: var(--new-green-color);\n    font-size: var(--space);\n    margin-left: var(--space-half-quarter);\n    line-height: var(--space-and-half);\n}\n\n.tournament-dynamic-form-question__add-btn .hubicon-add_option {\n    color: var(--new-green-color);\n    font-size: var(--space-and-half);\n}\n\n.tournament-dynamic-form-question__boolean-type {\n    display: flex;\n    align-items: center;\n}\n\n.tournament-dynamic-form-question__boolean-type span {\n    width: 20px;\n    height: 20px;\n    border: 3px solid rgba(0, 0, 0, 0.6);\n    border-radius: 50%;\n}\n\n.tournament-dynamic-form-question__boolean-type .baloa-username {\n    line-height: var(--space-and-half);\n    color: var(--primary-dark-color);\n    margin-left: var(--space-half);\n}\n\n.tournament-dynamic-form-question__boolean-type__container {\n    margin-top: var(--space-and-half);\n}\n\n.tournament-dynamic-form-question__boolean-type:first-of-type {\n    margin-bottom: var(--space);\n}\n\n.input-field__tip-message__wicon {\n    display: flex;\n    align-items: center;\n}\n\n.input-field__tip-message__wicon .hubicon-info {\n    margin-right: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
